import { useState } from 'react';
import axios from 'axios';

// Custom React hook for any loading operation. Provides method to invoke the appropriate handler.
// Assumes the use axios calls b/c we need axios cancel functionality (to stop a specific request)
// handlerCallback and handleErrCallback are optional, representing housekeeping to be done in either case and/or data retrieval.
export default function useLoading(asyncHandler, handlerCallback, handleErrCallback) {
    const [loading, setLoading] = useState(false);
    const [loaded, setLoaded] = useState(false);
    const handleLoad = () => {
        setLoading(true);

        asyncHandler()
        .then((data) => {
            setLoading(false);
            setLoaded(true);

            if (handlerCallback) {
                handlerCallback(data);
            }
        })
        .catch((err) => {
            if (axios.isCancel(err)) { // If call is interrupted by stop button!
                setLoading(false);
                return ;
            }
            
            setLoading(false);
            if (handleErrCallback) {
                handleErrCallback(err);
            }
        })
    };


    return { loading, loaded, setLoaded, handleLoad, setLoading };
}